import {
  en
} from './en'
import {
  zh
} from './zh'
import VueI18n from 'vue-i18n'
import Vue from 'vue'
import store from '../store/index'
Vue.use(VueI18n)

const messages = {
  en,
  zh
}
// console.log(store.state.locale, 'store.state.local')
// 通过选项创建 VueI18n 实例
const i18n = new VueI18n({
  locale: store.state.locale, // 设置地区
  messages, // 设置地区信息
})

export default i18n